import { render } from "./k-fields-repeater.vue?vue&type=template&id=53c09619"
import script from "./k-fields-repeater.vue?vue&type=script&lang=js"
export * from "./k-fields-repeater.vue?vue&type=script&lang=js"

import "./k-fields-repeater.vue?vue&type=style&index=0&id=53c09619&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__